import { Record } from 'immutable';
import { defaultDatasetPreferences, defaultUserPreferences } from './defaults';

export const Preferences = new Record(
  {
    shared: {
      user: {
        ...defaultUserPreferences,
        /*
        datasetIdsUsed: new List([]),
        webApp: {
          windowsReviewedWarningEnabled: true,
        },
        */
      },
      dataset: {
        webApp: {
          ...defaultDatasetPreferences,
        },
      },
    },
    /* these are not yet supported
    client: {
      user: {
      },
      dataset: {
      },
      global: {
      },
    },
    qcs: {},
    */
  }
);

export const PreferencesStore = new Record({
  loadPending: {
    shared: {
      user: true,
      dataset: true,
    },
  },
  preferences: new Preferences(),
  error: undefined,
});

